export function NoConnectionsWall() {
  return (
    <section className="rounded-2xl border border-dashed border-mystic-500 bg-white p-8 text-center shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-lynch-500">No Ad Connections</p>
      <h2 className="mt-3 text-xl font-semibold text-black-pearl-500">
        This site has not connected Meta, Google, or Reddit Ads yet.
      </h2>
      <p className="mt-3 text-sm text-lynch-500">
        Once a connection is enabled and the hourly sync runs, this page will populate with spend, clicks, and campaign
        performance.
      </p>
    </section>
  );
}
